(function () {
  $(document).ready(function () {
    // ============================================
    // DEBUG CONFIGURATION
    // ============================================
    const DEBUG = true; // Set to false to disable all logging

    // ============================================
    // LOGGER SETUP
    // ============================================
    const createLogger = () => {
      const logLevels = {
        debug: 0,
        info: 1,
        warning: 3,
        success: 4,
        error: 5
      };

      const colors = {
        debug: "#9b59b6",
        info: "#3498db",
        success: "#2ecc71",
        warning: "#f1c40f",
        error: "#e74c3c"
      };

      const currentLogLevel = logLevels.debug; // Log everything at debug level or higher

      const logFn = (type, ...args) => {
        if (DEBUG && logLevels[type] >= currentLogLevel) {
          console.log(
            `%cNP-FREE-BUILDER`,
            `background: ${colors[type]}; color: white; padding: 2px 5px; border-radius: 3px;`,
            ...args
          );
        }
      };

      return {
        debug: (...args) => logFn("debug", ...args),
        info: (...args) => logFn("info", ...args),
        success: (...args) => logFn("success", ...args),
        warning: (...args) => logFn("warning", ...args),
        error: (...args) => logFn("error", ...args)
      };
    };

    const log = createLogger();

    // ============================================
    // INITIALIZATION
    // ============================================
    let productBundlePacks = 2;
      const moneyFormat = $('#money_format').val();
      log.info("Money format:", moneyFormat)

      if (typeof Shopify === 'undefined') { var Shopify = {}; }
          if (typeof Shopify.formatMoney === 'undefined') {
            Shopify.formatMoney = function(cents, format) {
            if (typeof cents == 'string') {
            cents = cents.replace('.', '');
            }
            var value = '';
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var formatString = (format || this.money_format);
            function defaultOption(opt, def) {
                return (typeof opt == 'undefined' ? def : opt);
            }
            function formatWithDelimiters(number, precision, thousands, decimal) {
                precision = defaultOption(precision, 2);
                thousands = defaultOption(thousands, ',');
                decimal = defaultOption(decimal, '.');
                if (isNaN(number) || number == null) {
                    return 0;
                }
                number = (number / 100.0).toFixed(precision);
                var parts = number.split('.'),
                    dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                    cents = parts[1] ? (decimal + parts[1]) : '';
                return dollars + cents;
            }
            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
            }
            return formatString.replace(placeholderRegex, value);
          };
          }
  

    // GLOBAL VARIABLE
    const productItem = $(".lp-bundle__sticker-item");
    const bundle = $(".selected-bundle-container-ds .selected-bundle-ds");


    let productArray = JSON.parse(localStorage.getItem("isFreeSelectedItem")) || [];
    let selectedContent =
      JSON.parse(localStorage.getItem("isFreeActiveItem")) || [];

    if (selectedContent.length === 0) {
      productItem.each((_, val) => {
        val.setAttribute("data-product-quantity", 0);
      });
      $(".bundle-quantity").each((_, val) => {
        val.setAttribute("value", 0);
      });
    }

    if(productArray.length > productBundlePacks){
      $(".selected-items__counter").text(`Please remove ${Math.abs(productBundlePacks - productArray.length)} packs`);
    }else {
      $(".selected-items__counter").text(`Pick ${productBundlePacks - productArray.length} more Packs`);

    }

    
    function renderSelectedProducts(products) {
      const $container = $('.selected-product-details');
       $('.pack-btn .selected-items__price').hide();
      $container.show();
      $container.find('.product').remove();
      $('.total-section').remove();

      if (!products || products.length === 0) {
        $container.hide();
        return
      };

      // NEW TIERED PRICING LOGIC WITH CURRENCY CONVERSION
      // Base pricing in USD (cents)
      const bundlePricingUSD = {
        2: 1499,  // Buy 1 Get 1 FREE = $14.99 USD
        4: 2700,  // Buy 2 Get 2 FREE = $27.00 USD
        6: 3600,  // Buy 3 Get 3 FREE = $36.00 USD
        8: 4200   // Buy 4 Get 4 FREE = $42.00 USD
      };

      // Calculate exchange rate from actual product prices
      // Use the first product to determine the exchange rate
      const referenceProductPrice = parseInt(products[0].product_price, 10);
      const referenceProductBasePriceUSD = 1500; // $15.00 USD (typical single pack price)
      const exchangeRate = referenceProductPrice / referenceProductBasePriceUSD;

      log.debug('Currency conversion:', {
        referenceProductPrice,
        referenceProductBasePriceUSD,
        exchangeRate: exchangeRate.toFixed(4)
      });

      // Apply exchange rate to bundle pricing
      const bundlePricing = {};
      Object.keys(bundlePricingUSD).forEach(key => {
        bundlePricing[key] = Math.round(bundlePricingUSD[key] * exchangeRate);
      });

      log.debug('Converted bundle pricing:', bundlePricing);

      // Use converted pricing based on bundle size
      let totalPaid = bundlePricing[productBundlePacks] || 0;
      let originalGiftValue = 0;

    const paidCounts = {};
    const freeCounts = {};

      products.forEach((product, index) => {
      const isPaid = index + 1 <= productBundlePacks / 2;
            if (isPaid) {
                paidCounts[product.product_id] = (paidCounts[product.product_id] || 0) + 1;
          } else {
            // Calculate value of free items based on actual product prices
            originalGiftValue += parseInt(product.product_price, 10);
                freeCounts[product.product_id] = (freeCounts[product.product_id] || 0) + 1;
          }
      });

      // Total = paid items cost + original value of free items
      let allTotal = totalPaid + originalGiftValue;
      $container.find('.product-title').remove();
      let htmlOutput = "";
        // PAID section
        if (Object.keys(paidCounts).length > 0) {
            htmlOutput += `<h3 class="product-title">YOUR PICK</h3>`;
          Object.keys(paidCounts).forEach((id) => {
            const product = products.find(p => p.product_id == id);
            htmlOutput += `
              <div class="product" data-id="${id}">
                <p class="product-name">
                  ${paidCounts[id]}x ${product.product_title} 
                </p>
              </div>
            `;
          });
        }
      // FREE section
      if (Object.keys(freeCounts).length > 0) {
          htmlOutput += `<h3 class="product-title">YOUR FREE GIFT</h3>`;
        Object.keys(freeCounts).forEach((id) => {
          const product = products.find(p => p.product_id == id);
          htmlOutput += `
            <div class="product" data-id="${id}">
              <p class="product-name">
                ${freeCounts[id]}x ${product.product_title} 
              </p>
            </div>
          `;
        });
      }

      $container.append(htmlOutput);

      
        const save = totalPaid - originalGiftValue;
        const percentOff = (originalGiftValue / (totalPaid + originalGiftValue)) * 100;
         const totalHTML = `
          <div class="total-section">
            <h3 class="total-save">YOU SAVE: <span>${Shopify.formatMoney(originalGiftValue, moneyFormat)}</span><span class="total-percent-off">(${Math.trunc(percentOff)}% OFF)</span></h3>
            <h3 class="total-price">TOTAL: <span >${Shopify.formatMoney(totalPaid, moneyFormat)}</span></h3>
          </div>
        `;

        if(productArray.length === productBundlePacks) {
          $('.packs__active.pack-btn .selected-items__price').show();
           $('.packs__active.pack-btn .selected-items__price .price__before').text(Shopify.formatMoney(allTotal, moneyFormat))
          $('.packs__active.pack-btn .selected-items__price .price__after').text(Shopify.formatMoney(totalPaid, moneyFormat))
          $('.toggle-details-container').after(totalHTML);
        }

        const image = $('.selected-bundle-container-ds .selected-bundle-ds');
        const totalImg = image.length;
        const half = Math.floor(totalImg / 2);
        image.find('.badge').remove();

        image.each(function (index) {
          const hasID = $(this).attr('data-selected-id'); 
          const isFreeHalf = index >= totalImg - half;
          if (hasID && isFreeHalf) {
            $(this).append('<span class="badge">FREE</span>');
          }
        });
    }
    requestAnimationFrame(() => {
      renderSelectedProducts(productArray);
      // $('.packs__active.pack-btn .selected-items__price').show();
    });
    




    productItem.each(function (_, val) {
      selectedContent?.forEach((data) => {
        if (val.getAttribute("data-product-id") === data.product_id) {
          val.setAttribute(
            "data-product-selected",
            data.product_properties.product_selected
          );
          val.setAttribute(
            "data-product-quantity",
            data.product_properties.product_quantity
          );
          val
            .querySelector(".bundle-quantity-container .bundle-quantity")
            .setAttribute("value", data.product_properties.product_quantity);
        }
      });
    });

    // Add Initial Image
    for (let i = bundle.length - 1; i >= 0; i--) {
      if (i < productArray?.length) {
        $(bundle[i]).children("img").attr("src", productArray[i].product_img);
        $(bundle[i]).children("img").addClass("active");
        $(bundle[i]).attr("data-selected-id", productArray[i].product_id);
        $(bundle[i]).attr("data-selected-count", productArray[i].count);
        $(bundle[i]).children("button").css("display", "block");
      } else {
        $(bundle[i])
          .children("img")
          .attr("src", "//www.natpat.com/cdn/shop/files/lp-bundle-builder-empty-box.png?v=5829916032801006942");
        $(bundle[i]).attr("data-selected-id", "");
        $(bundle[i]).attr("data-selected-count", "");
      }
    }

    function disabledBtn() {
       const existing = $(".info-message");
       if (existing) existing.remove();

      const btn = $(".lp-bundle__sticker-item .sticker-item__cart");
     const parentNotAdded = btn.closest('.lp-bundle__sticker-item[data-product-selected="false"]');
    if ( productArray.length >= productBundlePacks / 2) {
      parentNotAdded.find('.sticker-item__cart').text('PICK YOUR FREE ONE');
      parentNotAdded.find('.sticker-item__cart').css({
        'max-width': 'unset',
        'font-size': '14px',
        'background': 'green',
        'color': '#fff'
      });
    }else {
        parentNotAdded.find('.sticker-item__cart').text('PICK FIRST');
        parentNotAdded.find('.sticker-item__cart').css({
         'max-width': '128px',
          'font-size': '17px',
          'background': '#1f4fd1',
          'color': '#fff'
      });
    }
      if (productArray.length === productBundlePacks) {
        btn.attr("disabled", true);
        btn.css("opacity", ".4");

        // Preview what will be submitted to cart
        log.info('=== PROCEED TO CHECKOUT BUTTON AVAILABLE ===');
        const previewPaidCounts = {};
        const previewFreeCounts = {};

        productArray.forEach((product, index) => {
          const isPaid = index + 1 <= productBundlePacks / 2;
          if (isPaid) {
            previewPaidCounts[product.product_id] = (previewPaidCounts[product.product_id] || 0) + 1;
          } else {
            previewFreeCounts[product.product_id] = (previewFreeCounts[product.product_id] || 0) + 1;
          }
        });

        const previewItems = [];
        Object.keys(previewPaidCounts).forEach((productId) => {
          const product = productArray.find(p => p.product_id == productId);
          previewItems.push({
            id: productId,
            title: product.product_title,
            quantity: previewPaidCounts[productId],
            position: 'paid'
          });
        });
        Object.keys(previewFreeCounts).forEach((productId) => {
          const product = productArray.find(p => p.product_id == productId);
          previewItems.push({
            id: productId,
            title: product.product_title,
            quantity: previewFreeCounts[productId],
            position: 'free'
          });
        });

        log.info('Cart items that will be submitted:', previewItems);
        const expectedPaid = productBundlePacks / 2;
        const expectedFree = productBundlePacks / 2;
        log.success(`Ready to submit ${previewItems.length} line items (${expectedPaid} paid + ${expectedFree} free)`);

        $(".btn-cart-all").css("display", "block");
        $(".selected-items__counter").css("display", "none");
        // $('.packs__active.pack-btn .selected-items__price').show();
      } else {
        btn.attr("disabled", false);
        btn.css("opacity", "1");
        // $('.packs__active.pack-btn .selected-items__price').hide();

      }

    // Disabled product that is free
    const btnDisabledLowerPrice = $('.lp-bundle__sticker-item[data-free="true"]').find('.sticker-item__cart')
      if($('.lp-bundle__sticker-item').attr('data-product-selected') == 'false'){
          btnDisabledLowerPrice.attr("disabled", true)
          btnDisabledLowerPrice.css("opacity", ".4");
      }
      if(productArray.length >= productBundlePacks / 2){
          btnDisabledLowerPrice.attr("disabled", false)
          btnDisabledLowerPrice.css("opacity", "1");
      }
    }
    disabledBtn();

    function addImage() {
       const bundle = $(".selected-bundle-container-ds .selected-bundle-ds");
      for (let i = bundle.length - 1; i >= 0; i--) {
        if (i < productArray.length) {
          $(bundle[i]).children("img").attr("src", productArray[i].product_img);
          $(bundle[i]).children("img").addClass("active");
          $(bundle[i]).attr("data-selected-id", productArray[i].product_id);
           $(bundle[i]).attr("data-selected-count", productArray[i].count);
          $(bundle[i]).children("button").css("display", "block");
        } else {
          $(bundle[i])
            .children("img")
            .attr("src", "//www.natpat.com/cdn/shop/files/lp-bundle-builder-empty-box.png?v=5829916032801006942");
          $(bundle[i]).children("img").removeClass("active");
          $(bundle[i]).attr("data-selected-id", "");
          $(bundle[i]).attr("data-selected-count", "");
          $(bundle[i]).children("button").css("display", "none");
        }
      }
    }

    productItem.click(function (e) {
      // return false if not targeted Btn
      if (!e.target) {
        return;
      }

      const targetedProduct = e.target;
      const targetedClass = targetedProduct.getAttribute("class");
      const selectedProduct = targetedProduct.closest(
        ".lp-bundle__sticker-item"
      );
      const productImg = selectedProduct
        .querySelector(".sticker-item_img")
        .getAttribute("src");
      const productId = selectedProduct.getAttribute("data-product-id");

      const product_price = selectedProduct.getAttribute("data-product-price");
      const product_compare_price = selectedProduct.getAttribute("data-compare-price");
      const product_save = selectedProduct.getAttribute("data-save");
      const product_title = selectedProduct.getAttribute("data-title");

      function addProduct() {
        const sameItems = productArray.filter(p => p.product_id === productId);
        const nextCount = sameItems.length + 1
        productArray.push({
          product_img: productImg,
          product_id: productId,
          product_price,
          product_compare_price,
          product_save,
          product_title,
          count: nextCount
        });

        localStorage.setItem("isFreeSelectedItem", JSON.stringify(productArray));
      }

      // Add Cart
      if (
        targetedClass === "sticker-item__cart" &&
        productArray.length < productBundlePacks
      ) {
          // Pack Builder v2 logic
          const existing = selectedProduct.querySelector(".info-message");
          const btn = selectedProduct.querySelector('.sticker-item__cart')
          if (existing) existing.remove();
        addProduct();
        addImage();
        disabledBtn();


        selectedProduct.setAttribute("data-product-selected", true);
        selectedProduct.setAttribute("data-product-quantity", 1);
        selectedProduct
          .querySelector(".bundle-quantity")
          .setAttribute("value", 1);
        selectedContent.push({
          product_id: productId,
          product_properties: {
            product_quantity: selectedProduct.getAttribute(
              "data-product-quantity"
            ),
            product_selected: selectedProduct.getAttribute(
              "data-product-selected"
            ),
          },
        });
        localStorage.setItem("isFreeActiveItem", JSON.stringify(selectedContent));
        $(".selected-items__counter").text(`Pick ${productBundlePacks - productArray.length} more Packs`);
        renderSelectedProducts(productArray);
      } 


      const latestQuantity = selectedProduct.getAttribute(
        "data-product-quantity"
      );
      const productID = selectedProduct.getAttribute("data-product-id");
      let quantity = +latestQuantity;

      // Add Quantity
      if (
        targetedClass === "bundle-increase-quantity" &&
        productArray.length < productBundlePacks
      ) {
        quantity++;

        selectedProduct.setAttribute("data-product-quantity", quantity);
        const updatedQuantity = selectedProduct.getAttribute(
          "data-product-quantity"
        );
        selectedProduct
          .querySelector(".bundle-quantity")
          .setAttribute("value", updatedQuantity);
        addProduct();
        addImage();

        // update Quantity
        selectedContent.forEach((data) => {
          if (data.product_id === productID) {
            data.product_properties.product_quantity = updatedQuantity;
          }
        });

        localStorage.setItem("isFreeActiveItem", JSON.stringify(selectedContent));
        disabledBtn();
        renderSelectedProducts(productArray);
        $(".selected-items__counter").text(`Pick ${productBundlePacks - productArray.length} more Packs`);
      }

      if (
        targetedClass === "bundle-decrease-quantity" &&
        productArray.length > 0
      ) {
        let quantityBeforeDecrease = quantity;
        if (quantity > 1) {
          quantity--;
        } else {
          quantity = 0;
        }

        selectedProduct.setAttribute("data-product-quantity", quantity);
        const updatedQuantity = selectedProduct.getAttribute(
          "data-product-quantity"
        );
        selectedProduct
          .querySelector(".bundle-quantity")
          .setAttribute("value", updatedQuantity);

        // Remove Product
        // const filteredProduct = productArray.filter((data) => {
        //   return data.product_id === productID;
        // });
        // filteredProduct.pop();
        // const otherProduct = productArray.filter((data) => {
        //   return data.product_id !== productID;
        // });

         const index = productArray.findIndex(p => p.product_id === productID && p.count === quantityBeforeDecrease);

          if (index !== -1) {
              productArray.splice(index, 1);  
          }
        // productArray = [...filteredProduct, ...otherProduct];
        localStorage.setItem("isFreeSelectedItem", JSON.stringify(productArray));
        addImage();

        // update Quantity
        const remove = selectedContent.filter((data) => {
          if (data.product_id === productID) {
            data.product_properties.product_quantity = updatedQuantity;
            if (quantity === 0) {
              data.product_properties.product_selected = false;
            }
          }
          return data.product_properties.product_quantity !== "0";
        });

        selectedContent = remove;
        if (quantity === 0) {
          selectedProduct.setAttribute("data-product-selected", false);
        }

        localStorage.setItem("isFreeActiveItem", JSON.stringify(selectedContent));
        disabledBtn();
        renderSelectedProducts(productArray);
        $(".btn-cart-all").css("display", "none");
        $(".selected-items__counter").css("display", "block");

        if(productArray.length > productBundlePacks){
          $(".selected-items__counter").text(`Please remove ${Math.abs(productBundlePacks - productArray.length)} Packs`);
        }else if(productArray.length == productBundlePacks){
          $(".btn-cart-all").css("display", "block");
          $(".selected-items__counter").css("display", "none");
        }else if (productArray.length < productBundlePacks){
          $(".selected-items__counter").text(`Pick ${productBundlePacks - productArray.length} more Packs`);
        }
      }
    });

    $(".selected-bundle-ds .remove-pack-item").click(function (e) {
      const targetBtn = $(this);
      const targetBtnParentEl = targetBtn.closest(".selected-bundle-container-ds .selected-bundle-ds");
      const selectedID = targetBtnParentEl.attr("data-selected-id");

      // // Remove Product
      // const filteredProduct = productArray.filter((data) => {
      //   return data.product_id === selectedID;
      // });
      // filteredProduct.pop();
      // const otherProduct = productArray.filter((data) => {
      //   return data.product_id !== selectedID;
      // });

      // productArray = [...filteredProduct, ...otherProduct];
       const selectedCount = Number(targetBtnParentEl.attr("data-selected-count"));
      const index = productArray.findIndex(p => p.product_id === selectedID &&  p.count === selectedCount);

      if (index !== -1) {
        productArray.splice(index, 1);  
      }
      localStorage.setItem("isFreeSelectedItem", JSON.stringify(productArray));
      addImage();

      const activeItem = $(".lp-bundle__sticker-item");
      activeItem.each(function (_, val) {
        if (val.getAttribute("data-product-id") === selectedID) {
          const latestQuantity = val.getAttribute("data-product-quantity");
          let quantity = +latestQuantity;
          if (quantity > 1) {
            quantity--;
          } else {
            quantity = 0;
          }

          val.setAttribute("data-product-quantity", quantity);
          const updatedQuantity = val.getAttribute("data-product-quantity");
          val
            .querySelector(".bundle-quantity")
            .setAttribute("value", updatedQuantity);

          const remove = selectedContent.filter((data) => {
            if (data.product_id === selectedID) {
              data.product_properties.product_quantity = updatedQuantity;
              if (quantity === 0) {
                data.product_properties.product_selected = false;
              }
            }
            return data.product_properties.product_quantity !== "0";
          });

          selectedContent = remove;
          if (quantity === 0) {
            val.setAttribute("data-product-selected", false);
          }
          localStorage.setItem("isFreeActiveItem", JSON.stringify(selectedContent));
        }
      });
      disabledBtn();
      $(".btn-cart-all").css("display", "none");
      $(".selected-items__counter").css("display", "block");
      if(productArray.length > productBundlePacks){
        $(".selected-items__counter").text(`Please remove ${Math.abs(productBundlePacks - productArray.length)} Packs`);
      }else if(productArray.length == productBundlePacks){
        $(".btn-cart-all").css("display", "block");
        $(".selected-items__counter").css("display", "none");
      }else if (productArray.length < productBundlePacks){
        $(".selected-items__counter").text(`Pick ${productBundlePacks - productArray.length} more Packs`);
      }
      renderSelectedProducts(productArray);
    });

    // $('.pack-btn').each(btn => {
    //    if(productBundlePacks !== 4){
    //     productBundlePacks = 4;
    //     $('.clone-bundle .selected-bundle-ds').slice(0, 1).clone().appendTo('.selected-bundle-container-ds');
    //     disabledBtn();
    //   }
    // })
    $('.packs-toggle__4-6-packs').on('click', '.pack-btn', function(){
      if(!$(this)){
        return
      }

      // Toggle Active
      $('.pack-btn').removeClass('packs__active')
      // $('.pack-btn .selected-items__price').hide();
      $(this).addClass('packs__active')

      const beforePrice = $(this).attr('data-price-before')
      const afterPrice = $(this).attr('data-price-after')
      const percentOff = $(this).attr('data-percent-off')

      // const bundleLength = $('.selected-bundle-container-ds .selected-bundle-ds').length
      // if($(this).attr('data-pack-count') == 5 && productBundlePacks !== 5){
      //   productBundlePacks = 5;
      //   if(bundleLength === 3){
      //     for(let i = 0; i < 2; i++){
      //       $('.clone-bundle .selected-bundle-ds').clone(true, true).appendTo('.selected-bundle-container-ds');
      //     }
      //   }
      //   if(bundleLength === 7){
      //     $('.selected-bundle-container-ds .selected-bundle-ds').slice(-2).remove();
      //   }
      // }
      // if($(this).attr('data-pack-count') == 7 && productBundlePacks !== 7){
      //   productBundlePacks = 7;
      //    if(bundleLength === 3){
      //     for(let i = 0; i < 4; i++){
      //       $('.clone-bundle .selected-bundle-ds').clone(true, true).appendTo('.selected-bundle-container-ds');
      //     }
      //   }
      //   if(bundleLength === 5){
      //     for(let i = 0; i < 2; i++){
      //       $('.clone-bundle .selected-bundle-ds').clone(true, true).appendTo('.selected-bundle-container-ds');
      //     }
      //   }
      // }
      // if($(this).attr('data-pack-count') == 3 && productBundlePacks !== 3){
      //    productBundlePacks = 3;
      //   if(bundleLength === 5){
      //       $('.selected-bundle-container-ds .selected-bundle-ds').slice(-2).remove();
      //   }
      //   if(bundleLength === 7){
      //       $('.selected-bundle-container-ds .selected-bundle-ds').slice(-4).remove();
      //   }
      // }

      const bundleLength = $('.selected-bundle-container-ds .selected-bundle-ds').length;
      const selectedPack = parseInt($(this).attr('data-pack-count'));

      if (selectedPack !== productBundlePacks) {
        productBundlePacks = selectedPack;

        const diff = selectedPack - bundleLength;

        if (diff > 0) {
          for (let i = 0; i < diff; i++) {
            $('.clone-bundle .selected-bundle-ds').clone(true, true).appendTo('.selected-bundle-container-ds');
          }
        } else if (diff < 0) {
          $('.selected-bundle-container-ds .selected-bundle-ds').slice(diff).remove(); 
        }
      }

        if(productArray.length > productBundlePacks){
          $(".selected-items__counter").text(`Please remove ${Math.abs(productBundlePacks - productArray.length)} Packs`);
          $(".btn-cart-all").css("display", "none");
          $(".selected-items__counter").css("display", "block");
        }else if(productArray.length == productBundlePacks){
          // DEBUG: Validate button enable condition
          log.debug('=== BUTTON ENABLE VALIDATION ===');
          log.debug('productBundlePacks:', productBundlePacks);
          log.debug('productArray.length:', productArray.length);
          log.debug('productArray:', productArray);
          log.debug('selectedContent.length:', selectedContent.length);
          log.debug('selectedContent:', selectedContent);

          // Calculate expected paid/free split
          const expectedPaid = productBundlePacks / 2;
          const expectedFree = productBundlePacks / 2;
          log.debug(`Expected split: ${expectedPaid} paid, ${expectedFree} free`);

          // Show which items would be paid vs free based on current logic
          selectedContent.forEach((item, index) => {
            const bundlePosition = index < productBundlePacks / 2 ? 'paid' : 'free';
            log.debug(`  [${index}] ${item.product_title || item.product_id} (qty: ${item.product_properties?.product_quantity || 1}) -> ${bundlePosition}`);
          });

          $(".btn-cart-all").css("display", "block");
          $(".selected-items__counter").css("display", "none");
        }else if (productArray.length < productBundlePacks){
          $(".selected-items__counter").text(`Pick ${productBundlePacks - productArray.length} more Packs`);
          $(".btn-cart-all").css("display", "none");
          $(".selected-items__counter").css("display", "block");
        }
        // $('.selected-items__price .price__before').text(beforePrice)
        // $('.selected-items__price .price__after').text(afterPrice)
        $('.packs-toggle__percent-save span').text(percentOff)

        addImage()
        disabledBtn();
        renderSelectedProducts(productArray);
    })

    // New AJAX cart addition with custom properties for BOGO discount
    $(".btn-cart-all").click(async function(e) {
      e.preventDefault();

      const button = $(this);
      const originalText = button.text();
      button.text('Adding to cart...').prop('disabled', true);

      try {
        // DEBUG: Log current state
        log.info('=== FREE BUILDER CART SUBMISSION ===');
        log.debug('productBundlePacks:', productBundlePacks);
        log.debug('productArray:', productArray);
        log.debug('productArray.length:', productArray.length);

        // Use the SAME logic as frontend rendering (lines 95-105)
        // Build paid/free counts based on productArray (individual selections in order)
        const paidCounts = {};
        const freeCounts = {};

        productArray.forEach((product, index) => {
          const isPaid = index + 1 <= productBundlePacks / 2;
          log.debug(`[${index}] ${product.product_title} -> ${isPaid ? 'PAID' : 'FREE'}`);

          if (isPaid) {
            paidCounts[product.product_id] = (paidCounts[product.product_id] || 0) + 1;
          } else {
            freeCounts[product.product_id] = (freeCounts[product.product_id] || 0) + 1;
          }
        });

        log.debug('Paid counts:', paidCounts);
        log.debug('Free counts:', freeCounts);

        // Build cart items array
        const items = [];

        // Add paid items
        Object.keys(paidCounts).forEach((productId) => {
          items.push({
            id: productId,
            quantity: paidCounts[productId],
            properties: {
              '_bundle_type': 'free_builder',
              '_bundle_position': 'paid'
            }
          });
        });

        // Add free items
        Object.keys(freeCounts).forEach((productId) => {
          items.push({
            id: productId,
            quantity: freeCounts[productId],
            properties: {
              '_bundle_type': 'free_builder',
              '_bundle_position': 'free'
            }
          });
        });

        log.debug('Cart items to add:', items);

        // Validation check
        const totalItems = items.reduce((sum, item) => sum + item.quantity, 0);
        const expectedPaid = productBundlePacks / 2;
        const expectedFree = productBundlePacks / 2;
        const actualPaid = Object.values(paidCounts).reduce((sum, count) => sum + count, 0);
        const actualFree = Object.values(freeCounts).reduce((sum, count) => sum + count, 0);

        log.debug(`Validation: Total=${totalItems}, Expected=${productBundlePacks}, Paid=${actualPaid}/${expectedPaid}, Free=${actualFree}/${expectedFree}`);

        // Alert validation error
        if (totalItems !== productBundlePacks || actualPaid !== expectedPaid || actualFree !== expectedFree) {
          alert(`ERROR: Item counts don't match!\nTotal: ${totalItems}/${productBundlePacks}\nPaid: ${actualPaid}/${expectedPaid}\nFree: ${actualFree}/${expectedFree}\n\nCheck console for details.`);
          button.text(originalText).prop('disabled', false);
          return;
        }

        // STEP 1: Clear cart first (like lpv2-product-form.js)
        log.info("Clearing cart...");
        try {
          const response = await fetch("/cart/clear.js", { method: "POST" });
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          log.success("Cart cleared successfully");
        } catch (error) {
          log.error("Error clearing cart:", error);
          alert("There was an error clearing the cart. Please try again.");
          button.text(originalText).prop('disabled', false);
          return;
        }

        // Add free gift item if specified
        const freeGiftItem = button.data('free-gift');
        if (freeGiftItem) {
          items.push({
            id: freeGiftItem,
            quantity: 1
          });
        }

        // STEP 2: Create form submission (like lpv2-product-form.js)
        log.info("Creating form submission...");
        const form = document.createElement("form");
        form.method = "POST";
        form.action = "/cart/add";

        // Add each item with properties
        items.forEach((item, index) => {
          // Add variant ID
          const idInput = document.createElement("input");
          idInput.type = "hidden";
          idInput.name = `items[${index}][id]`;
          idInput.value = item.id;
          form.appendChild(idInput);

          // Add quantity
          const qtyInput = document.createElement("input");
          qtyInput.type = "hidden";
          qtyInput.name = `items[${index}][quantity]`;
          qtyInput.value = item.quantity;
          form.appendChild(qtyInput);

          // Add properties if they exist
          if (item.properties) {
            Object.keys(item.properties).forEach((propKey) => {
              const propInput = document.createElement("input");
              propInput.type = "hidden";
              propInput.name = `items[${index}][properties][${propKey}]`;
              propInput.value = item.properties[propKey];
              form.appendChild(propInput);
            });
          }
        });

        // Add discount code if present
        const discountCode = button.data('discount-code');
        if (discountCode) {
          const discountInput = document.createElement("input");
          discountInput.type = "hidden";
          discountInput.name = "discount";
          discountInput.value = discountCode;
          form.appendChild(discountInput);
        }

        // STEP 3: Add return_to=/checkout/ to go straight to checkout
        const checkoutInput = document.createElement("input");
        checkoutInput.type = "hidden";
        checkoutInput.name = "return_to";
        checkoutInput.value = "/checkout";
        form.appendChild(checkoutInput);

        // STEP 4: Submit form (navigates to checkout, auto-closes cart drawer)
        document.body.appendChild(form);
        log.info("Submitting form to checkout...");
        form.submit();

      } catch (error) {
        log.error("Error adding items to cart:", error);
        button.text(originalText).prop('disabled', false);
        alert("There was an error adding items to your cart. Please try again.");
      }
    });


    const removeTime = 10000;
    let timer;

    function resetTime() {
      clearTimeout(timer);
      timer = setTimeout(removeDataStorage, removeTime);
    }

    function removeDataStorage() {
      localStorage.removeItem("isFreeActiveItem");
      localStorage.removeItem("isFreeSelectedItem");
    }

    function handleUserActivity() {
      resetTime();
    }

    document.addEventListener("mousemove", handleUserActivity);
    document.addEventListener("scroll", handleUserActivity);
    resetTime();

    const reviewsTitle = document.createElement('h3');
    reviewsTitle.innerText = '4.85/5';
    reviewsTitle.classList.add('text-rate');

    setTimeout(()=> {
      $('.jdgm-rev-widg__summary-inner').before(reviewsTitle)
    }, 3000);

    $('#lp-bundle__free-shipping').insertBefore('.header-wrapper');
   
  });
})();
